import React, { useEffect } from "react";
import { WizardFormData } from "../types/wizard.types";

interface CommittedClubAppStepProps {
  formData: WizardFormData;
  onFormUpdate: (data: Partial<WizardFormData>) => void;
  onValidationChange: (isValid: boolean) => void;
}

const CommittedClubAppStep: React.FC<CommittedClubAppStepProps> = ({
  onValidationChange,
}) => {
  useEffect(() => {
    onValidationChange(true);
  }, [onValidationChange]);

  return (
    <div>
      <div>
        <ul className="tw-list-disc tw-list-outside tw-pl-6 tw-text-neutral-800/80 tw-space-y-3">
          <li className="tw-leading-relaxed">
            Create member challenges and competitions
          </li>
          <li className="tw-leading-relaxed">
            Share workout achievements and progress
          </li>
          <li className="tw-leading-relaxed">
            Build social connections between members
          </li>
          <li className="tw-leading-relaxed">
            Celebrate milestones and success stories
          </li>
        </ul>
      </div>
    </div>
  );
};

export default CommittedClubAppStep;
